import { io } from "socket.io-client";
import type { ManagerOptions, SocketOptions } from "socket.io-client";

export const buildSocketClient = (
  url: string,
  options: Partial<ManagerOptions & SocketOptions>,
) => {
  return io(url, options);
};
